<div class="sw-cms-preview-block-moorl-interactive-slider">
    <mt-icon
        name="regular-chevron-left-s"
        size="10"
    />
    <div>&infin;</div>
    <mt-icon
        name="regular-chevron-right-s"
        size="10"
    />
</div>